import { useOn } from "@/lib/features";
import { CalendarHeart, Phone } from "lucide-react";
import { useContent } from "@/lib/content";
import { Logo } from "./Header";
import { PolicyLinks } from "@/pages/Policy";
import { SocialLinks } from "./Social";
import { BookLink } from "@/lib/fresha";

export const Footer = () => {
  const { contact: c, footer: f } = useContent().data;
  const msgs = useOn("messages");
  return (
    <footer data-testid="site-footer">
      <div className="footergrid">
        <div><Logo testId="footer-logo" variant="gold" /><p>{f.tagline}</p><SocialLinks dark /></div>
        <div>
          <strong>Explore</strong>
          <p><a href="#services">Services</a><br /><a href="#prices">Prices</a><br /><BookLink testId="footer-book-link">Appointments</BookLink>{msgs && <><br /><a href="#contact" data-testid="footer-contact-link">Send us a message</a></>}</p>
        </div>
        <div>
          <strong>Contact</strong>
          <p><a href={`tel:${c.phone_call}`} data-testid="footer-phone-1">{c.phone_call_label}</a><br />
            <a href={`tel:${c.phone_alt}`} data-testid="footer-phone-2">{c.phone_alt_label}</a><br />
            <a href={`mailto:${c.booking_email}`} data-testid="footer-email">{c.booking_email}</a><br />{c.address}</p>
        </div>
      </div>
      <PolicyLinks dark />
      <div className="copyright">{f.copyright}</div>
    </footer>
  );
};

export const MobileBar = () => {
  const c = useContent().data.contact;
  return (
    <div className="mobilebar" data-testid="mobile-action-bar">
      <BookLink className="btn gold" testId="mobile-bar-book-button"><CalendarHeart size={17} /> Book</BookLink>
      <a className="btn dark" href={`tel:${c.phone_call}`} data-testid="mobile-bar-call-button"><Phone size={17} /> Call</a>
    </div>
  );
};
